import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../context/ThemeContext";

function NavbarMenu({ toggle, setToggle }) {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isLight = theme === 'light';

  return (
    <>
      {/* Backdrop */}
      <div
        className={`tw-fixed tw-inset-0 tw-z-40 tw-bg-black/60 tw-transition-opacity tw-duration-300 md:tw-hidden ${
          toggle ? "tw-opacity-100 tw-pointer-events-auto" : "tw-opacity-0 tw-pointer-events-none"
        }`}
        onClick={() => setToggle(false)}
      />

      {/* Bottom sheet */}
      <div
        className={`tw-fixed tw-inset-x-0 tw-bottom-0 tw-z-50 tw-rounded-t-2xl tw-border-t tw-border-[#FF43A7]/30 tw-shadow-2xl tw-transition-transform tw-duration-300 tw-ease-out md:tw-hidden ${
          toggle ? "tw-translate-y-0" : "tw-translate-y-full"
        } ${isLight ? 'tw-bg-white' : 'tw-bg-[#1C0039]'}`}
      >
        {/* Drag handle */}
        <div className="tw-flex tw-justify-center tw-pt-3 tw-pb-1">
          <div className="tw-h-1 tw-w-10 tw-rounded-full tw-bg-[#FF43A7]/40" />
        </div>

        <div className="tw-px-6 tw-pt-4 tw-pb-10 tw-flex tw-flex-col tw-gap-3">
          <Link
            to="/login"
            onClick={() => setToggle(false)}
            className="tw-block tw-w-full tw-py-3 tw-text-center tw-rounded-full tw-border tw-border-[#FF43A7]/60 tw-bg-transparent tw-text-sm tw-font-semibold tw-text-[#FF43A7] hover:tw-bg-[#FF43A7]/15 tw-transition-all tw-no-underline"
          >
            {t("Login")}
          </Link>
          <Link
            to="/signup"
            onClick={() => setToggle(false)}
            className="tw-block tw-w-full tw-py-3 tw-text-center tw-rounded-full tw-border tw-border-[#FF43A7]/60 tw-bg-[#FF43A7]/15 tw-text-sm tw-font-semibold tw-text-[#FF43A7] hover:tw-bg-[#FF43A7]/25 tw-transition-all tw-no-underline"
          >
            {t("Register")}
          </Link>
        </div>
      </div>
    </>
  );
}

export default NavbarMenu;
